import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[#1A201D] text-[#E2E0DA]">
      <div className="container-rotam py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <span className="text-2xl font-heading font-medium tracking-tight text-white">ROTAM</span>
              <span className="text-[10px] tracking-[0.25em] uppercase text-rotam-accent">
                Tax & Financial Advisory
              </span>
            </Link>
            <p className="mt-6 text-sm leading-relaxed text-[#C8CCC8] max-w-md">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="overline text-rotam-accent mb-5">{t.footer.navTitle}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">{t.nav.home}</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">{t.nav.services}</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">{t.nav.blog}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="overline text-rotam-accent mb-5">{t.footer.contactTitle}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-rotam-accent shrink-0" />
                <span>{t.contact.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-rotam-accent shrink-0" />
                <a href={`tel:${t.contact.phoneNumber.replace(/\s/g, "")}`} className="hover:text-white">
                  {t.contact.phoneNumber}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-rotam-accent shrink-0" />
                <a href={`mailto:${t.contact.emailAddress}`} className="hover:text-white">
                  {t.contact.emailAddress}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#9AA09C]">
          <p>© {year} ROTAM Tax & Financial Advisory. {t.footer.rights}</p>
          <p className="tracking-[0.2em] uppercase">Türkiye · Istanbul</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
